<template>
    <div v-bind:id="idStr+contentKey" class="famous-comment-eidt-panel" @click="clickEidtPanel">
        <div class="famous-comment-edit-note dsp-flex">
            <div class="famous-comment-edit-avatar">
                <img class="famous-cea-img" v-bind:src="avatar" alt="">
            </div>
            <div class="famous-comment-edit-content" v-bind:class="{'famous-comment-edit-content-focus' : focused}">
                <span class="famous-cea-note">我来说两句...</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FamousCommentEditPanel',
    props: {
        avatar: {
            type: String,
            default() { return '' }
        },
        contentKey: {
            type: String,
            default() { return '' }
        },
        editFunc: {
            type: Function,
            default() { return null }
        }
    },
    data() {
        return {
            idStr: 'edit_',
            focused: false
        }
    },
    methods: {
        clickEidtPanel() {
            if(this.editFunc && typeof(this.editFunc) == 'function') {
                this.editFunc(this.idStr + this.contentKey);
            }
        }
    }
}
</script>